<template>
  <section class="smart-points-container" :class="mobileSelectionExpanded ? 'expanded' : ''">
    <div class="smart-points-infos-container" ref="infosContainer">
      <div class="smart-points-search">
        <div class="smart-points-search-container">
          <input type="text"
                 class="smart-points-search-container-input"
                 placeholder="Search"
                 aria-label="Search"
                 v-model="searchInput"
                 @keydown.enter.prevent="searchSmartPoints(searchInput)"
          />
          <button class="smart-points-search-container-button"
                  type="button"
                  @click="searchSmartPoints(searchInput)"
          ><i class="lni lni-search-alt"></i></button>
        </div>
      </div>
      <div class="smart-points-infos-item-container">
        <div
          v-for="smartPoint in cachedFilteredSearchedClosestSmartPoints"
          :key="smartPoint.id"
          class="smart-points-infos-item"
          :class="getSmartPointChecked(smartPoint) ? 'checked' : ''"
        >
          <div class="smart-points-infos-item-card">
            <div class="smart-points-infos-item-card-body" @click="setSmartPointChecked(smartPoint)">
              <ul class="smart-points-infos-item-card-body-infos">
                <li class="smart-points-infos-item-card-body-info"><h6 class="text-dark">{{smartPoint.name}}</h6></li>
                <li class="smart-points-infos-item-card-body-info">{{smartPoint.address}}</li>
                <li class="smart-points-infos-item-card-body-info">{{smartPoint.postalCode}} {{smartPoint.country}}</li>
                <li class="smart-points-infos-item-card-body-info point-checkbox" :class="getSmartPointChecked(smartPoint) ? 'checked' : ''">
                  <i class="lni lni-checkmark"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="smart-points-continue">
        <button @click="$root.$emit('modal-close')" name="Continue" type="button" value="Continue" class="smart-points-continue-btn">
          {{ t('preview.order.continue') }}
        </button>
      </div>
    </div>
    <div class="smart-points-map-container">
      <div v-if="getGoogleMapLoading" class="lds-ripple-container">
        <div class="lds-ripple"><div></div><div></div></div>
      </div>
      <section :style="!getGoogleMapLoading ? '' : 'opacity: 0'" class="smart-points-map">
        <div id="map" style="height: 100%; width: 100%"></div>
      </section>
    </div>
    <div class="smart-points-expand-button" @click="manageExpand()">
      <i :class="mobileSelectionExpanded ? 'lni lni-arrow-down' : 'lni lni-arrow-up'"></i>
    </div>
  </section>
</template>

<script>
import googleMapMixin from '../googleMaps/mixins/googleMapMixin'

export default {
  name: 'SmartPointMap',
  mixins: [googleMapMixin]
}
</script>

<style lang="scss" scoped>
  .smart-points {
    &-container {
      position: relative;
      display: grid;
      grid-template-columns: 1fr 3fr;
      grid-template-rows: 1fr;
      grid-row-gap: 3rem;
      transition: all .5s ease;
      @media screen and (max-width: 1200px) {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr;
        grid-row-gap: 0.25rem;
      }
      @media screen and (max-width: 767px) {
        grid-template-rows: 2fr 1fr;
        grid-row-gap: 0;
      }
      &.expanded {
        @media screen and (max-width: 767px) {
          grid-template-rows: 1fr 2fr;
          .smart-points-infos-container {
            max-height: 515px;
          }
          .smart-points-expand-button {
            top: 28%;
          }
        }
      }
    }
    &-map {
      position: relative;
      height: 100%;
      max-height: 650px;
      @media screen and (max-width: 1200px) {
        max-height: 350px;
      }
      @media screen and (max-width: 767px) {
        max-height: 590px;
      }
      &-container {
        transition: all .5s ease;
        @media screen and (max-width: 1200px) {
          grid-row: 1;
        }
        @media screen and (max-width: 767px) {
          max-height: 590px;
        }
      }
    }
    &-search {
      z-index: 10;
      width: 100%;
      height: auto;
      position: sticky;
      top: 0;
      @media screen and (max-width: 1200px) {
        max-width: unset;
      }
      @media screen and (max-width: 767px) {
        position: fixed;
        display: grid;
        top: 10px;
        z-index: 10;
      }
      &-container {
        display: grid;
        padding: 1rem;
        grid-template-columns: auto 25%;
        background-color: rgba(205, 206, 210);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        justify-self: center;
        align-self: center;
        transition: all 0.3s ease-in-out;
        @media screen and (max-width: 1200px) {
          border-top-left-radius: unset;
        }
        @media screen and (max-width: 767px) {
          padding: 0;
          background: white;
          border: 0.1rem solid #c2c2c2;
          border-radius: unset;
        }
        &-input {
          display: block;
          width: 100%;
          padding: 9px 13px;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.5;
          background-color: white;
          background-clip: padding-box;
          border: unset;
          border-radius: unset;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          transition: all 0.3s ease-in-out;
          &:focus {
            outline: none;
          }
          @media screen and (max-width: 767px) {
            border-top-left-radius: unset;
            border-bottom-left-radius: unset;
          }
        }
        &-button {
          transition: all 0.3s ease-in-out;
          background-color: white;
          border: 0;
          padding: 10px;
          text-align: center;
          width: 100%;
          margin: 0 auto;
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
          text-decoration: none;
          vertical-align: middle;
          cursor: pointer;
          display: inline-block;
          font-weight: 400;
          line-height: 1.5;
          user-select: none;
          font-size: 14px;
          -webkit-user-select: none;
          @media screen and (max-width: 767px) {
            border-top-right-radius: unset;
            border-bottom-right-radius: unset;
          }
        }
      }
    }
    &-continue {
      z-index: 10;
      width: 100%;
      height: auto;
      position: sticky;
      bottom: 0;
      border-bottom-left-radius: 10px;
      &-btn {
        width: 100%;
        padding: 0;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        font-size: 20px;
        font-weight: 700;
        color: #121218;
        background-color: rgb(229, 247, 239);
        border: 1px solid #8989899e;
        border-radius: 5px;
        &:hover {
          background-color: #7de17d;
        }
      }
    }
    &-infos {
      &-container {
        max-height: 650px;
        height: 100%;
        position: relative;
        overflow: auto;
        padding-right: 1rem;
        transition: all .5s ease;
        @media screen and (max-width: 1200px) {
          grid-row: 2;
          max-height: 350px;
        }
        @media screen and (max-width: 767px) {
          max-height: 260px;
          padding: 0;
        }
      }
      &-item {
        &.checked {
          grid-row: 1;
          z-index: 100;
          width: 100%;
          height: auto;
          position: sticky;
          top: 0;
          background-color: rgb(229 247 239);
          box-shadow: 0 4px 2px -2px #8eb0a37a;
        }
        &:hover {
          background-color: rgb(229 247 239);
        }
        &-card {
          width: 100%;
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          min-width: 0;
          word-wrap: break-word;
          background-clip: border-box;
          border-radius: 0.375rem;
          border: 0;
          background-color: transparent;
          position: relative;
          -webkit-box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
          box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
          &-body {
            border: 0;
            background-color: transparent;
            flex: 1 1 auto;
            min-height: 1px;
            padding: 1rem;
            color: #8492A6;
            @media screen and (max-width: 767px) {
              padding: 0.5rem;
            }
            &:hover {
              cursor: pointer;
            }
            &-infos {
              display: grid;
              grid-template-rows: auto;
              grid-template-columns: 6fr auto;
              align-items: center;
              grid-column-gap: 1rem;
              padding-left: 0;
              margin-bottom: 0;
            }
            &-info {
              display: grid;
              grid-column: 1;
              font-size: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 75ch;
              transition: all 0.3s ease-in-out;
              &.point-checkbox {
                display: grid;
                grid-column: 2;
                grid-row: 2 / span 1;
                width: fit-content;
                justify-items: center;
                justify-self: center;
                align-items: center;
                background: #cececede;
                border-radius: 50px;
                .lni {
                  padding: 8px;
                  color: white;
                  font-size: 14px;
                  line-height: 14px;
                  font-weight: 900;
                  width: 100%;
                  height: 100%;
                  border-left: 1px solid #cdced2d4;
                  display: grid;
                  align-content: center;
                  align-items: center;
                }
              }
              &.checked {
                background-color: #7de17d;
                transition: all 0.3s ease-in-out;
              }
              &-map-url {
                display: flex;
                background: #cdf0ea;
                max-width: fit-content;
                align-items: center;
                gap: 0.25rem;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
                border-radius: 5px;
              }
              h6 {
                @media screen and (max-width: 767px) {
                  margin: 0;
                }
              }
            }
          }
        }
        &-container {
          display: grid;
          @media screen and (max-width: 1200px) {
            padding-top: 0;
          }
        }
      }
    }
    &-expand-button {
      @media screen and (min-width: 768px) {
        display: none;
      }
      position: absolute;
      z-index: 1000;
      top: 61%;
      left: 50%;
      -ms-transform: translate(-50%,50%);
      transform: translate(-50%,50%);
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      width: 2.2rem;
      height: 2.2rem;
      background-color: #7de17d;
      border-radius: 50%;
      i {
        color: white;
      }
    }
  }
  .lds-ripple-container {
    position: relative;
    display: grid;
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
    background: rgba(206, 206, 206, 0.25);
    border-radius: 5px;
  }
  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid #7de17d;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    4.9% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    5% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0;
      left: 0;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
</style>
